'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002epackage$0024 from "./scala.package$.js";
import * as $j_scala$002eutil$002e$002dEither$0024$002dLeft$002dProjection from "./scala.util.-Either$-Left-Projection.js";
import * as $j_scala$002eutil$002e$002dFailure from "./scala.util.-Failure.js";
import * as $j_scala$002eutil$002e$002dLeft from "./scala.util.-Left.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
import * as $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024 from "./scala.util.control.-Non-Fatal$.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$() {
}
export { $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ as $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ };
$p = $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$() {
}
export { $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ as $h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ };
$h_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$.prototype = $p;
$p.jx = (function(str) {
  try {
    var $x_1 = new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success($j_scala$002epackage$0024.$m_s_package$().jh().O4(str));
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    matchResult1: {
      var $x_1;
      var x2 = $j_scala$002eutil$002econtrol$002e$002dNon$002dFatal$0024.$m_s_util_control_NonFatal$().ht(e$2);
      if ((!x2.k())) {
        var $x_1 = new $j_scala$002eutil$002e$002dFailure.$c_s_util_Failure(x2.C());
        break matchResult1;
      }
      throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
    }
  }
  var this$6 = new $j_scala$002eutil$002e$002dEither$0024$002dLeft$002dProjection.$c_s_util_Either$LeftProjection($x_1.QG());
  var x92 = this$6.qL;
  if ((x92 instanceof $j_scala$002eutil$002e$002dLeft.$c_s_util_Left)) {
    return new $j_scala$002eutil$002e$002dLeft.$c_s_util_Left(x92.gp.ii());
  }
  return this$6.qL;
});
var $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$, "dev.cheleb.scalamigen.Validator$given_Validator_BigInt$", ({
  jj: 1,
  bn: 1
}));
export { $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ as $d_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ };
var $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$;
function $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$() {
  if ((!$n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$)) {
    $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ = new $c_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$();
  }
  return $n_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$;
}
export { $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ as $m_Ldev_cheleb_scalamigen_Validator$given\uff3fValidator\uff3fBigInt$ };
